import { useEffect, useState } from 'react';
import PMGProjectIcon from '../../assets/icons/pmg-project.svg';
import Button from '../../components/Button/Button';
import SearchBar from '../../components/Common/SearchBar/SearchBar';
import CustomPagination from '../../components/Common/CustomPagination/CustomPagination';
import CustomTable from '../../components/Common/CustomTable/CustomTable';
import { EditOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { addIoAllocation, editIoAllocation, getIoAllocationListing } from '../../redux/adminUnitReportSlice/adminUnitReportSlice';
import openNotification from '../../components/Common/OpenNotification';
import AddIoAllocation from '../../components/Modals/AddIoAllocation';
import { PATHNAME } from '../../pathname';
import { useNavigate } from 'react-router-dom';

const IoAllocation = () => {
        const [searchValue, setSearchValue] = useState('');
        const [currentPage, setCurrentPage] = useState(1);
        const [isModalOpen, setIsModalOpen] = useState(false);
        const [editProject, setEditProject] = useState({});
        const [ioNo, setIoNo] = useState('');
        const dispatch = useDispatch();
        const navigate = useNavigate();
        const { ioAllocationListing, totalIoAllocationListing } = useSelector((state) => state.unitReport);

        const handleAdd = async (formData) => {
                let response;
                if (editProject && Object.keys(editProject).length > 0) {
                        response = await dispatch(editIoAllocation(formData));
                } else {
                        response = await dispatch(addIoAllocation(formData));
                }

                const status = response?.payload?.status;

                if (status === 'success') {
                        dispatch(
                                getIoAllocationListing({
                                        page: currentPage,
                                        size: '10',
                                        search: searchValue,
                                }),
                        );
                        openNotification('success', editProject?.IO_NO ? 'Updated' : 'Added', 'Success');
                        setIsModalOpen(false); // ✅ Only close on success
                }

                return { status }; // ✅ Return status for child to handle
        };

        const pageSize = 10; // Items per page
        const columns = [
                {
                        title: 'IO Number',
                        dataIndex: 'IO_NO',
                        key: 'IO_NO',
                        width: 180,
                        render: (text, record) => (
                                <div className="flex items-center justify-between gap-2">
                                        <span>{text}</span>
                                        <EditOutlined
                                                className="text-blue-500 cursor-pointer"
                                                onClick={() => {
                                                        setEditProject(record);
                                                        setIsModalOpen(true);
                                                }}
                                        />
                                </div>
                        ),
                },
                {
                        title: 'Revision Number',
                        dataIndex: 'REV_NO',
                        key: 'REV_NO',
                        width: 150,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Manufacturing Unit',
                        dataIndex: 'MNF_UNIT',
                        key: 'MNF_UNIT',
                        width: 150,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'BS Unit',
                        dataIndex: 'BS_UNIT',
                        key: 'BS_UNIT',
                        width: 150,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Head Type',
                        dataIndex: 'HEAD_TYPE',
                        key: 'HEAD_TYPE',
                        width: 150,
                        render: (text) => <div className="text-right">{text}</div>,
                },
                {
                        title: 'Allocated Value (₹)',
                        dataIndex: 'ALLOCATED_VALUE',
                        key: 'ALLOCATED_VALUE',
                        width: 200,
                        render: (text) => <div className="text-right">{Number(text)?.toLocaleString('en-IN')}</div>,
                },
        ];

        useEffect(() => {
                dispatch(
                        getIoAllocationListing({
                                page: currentPage,
                                size: '10',
                                search: searchValue,
                        }),
                );
        }, [currentPage, searchValue]);

        return (
                <div className="pb-14">
                        <div className="px-5 flex flex-col gap-6 pt-4">
                                <div className="flex gap-3">
                                        {/* <img
                                                src={PMGProjectIcon}
                                                alt="region"
                                        /> */}
                                        <div>
                                                <div className="font-inter font-semibold text-[18px] leading-[24px] tracking-[0%] text-[#101828]">IO Allocation</div>
                                                <div className="font-inter font-normal text-[13px] leading-[20px] tracking-[0%] text-[#475467]">List of io allocation</div>
                                        </div>
                                </div>
                                <div className="text-gray-500 text-sm flex justify-start">* All figures are in Rupees (in thousand).</div>
                                <div className="mt-[8px] flex justify-between">
                                        <SearchBar
                                                className="!w-[330px]"
                                                onSearch={setSearchValue}
                                                placeholder="Search by IO Number"
                                        />


                                        <div className="flex">
                                                <div className="mr-4">
                                                <Button onClick={() => navigate(PATHNAME.ADMIN_UPLOAD_CSV_FILES_IO_ALLOCATION)}
                                                text="Upload"
                                                variant="primary"
                                                />

                                                </div>

                                                <div className="flex gap-[12px]">
                                                <Button
                                                        text="+ Add IO Allocation"
                                                        variant="primary"
                                                        onClick={() => {
                                                                setIsModalOpen(true);
                                                                setEditProject({});
                                                        }}
                                                />
                                        </div>
                                         
                                        </div>



                                </div>
                                <div className=" flex flex-col gap-6">
                                        <CustomTable
                                                dataSource={ioAllocationListing}
                                                columns={columns}
                                        />
                                        <div>
                                                <CustomPagination
                                                        totalItems={totalIoAllocationListing}
                                                        pageSize={pageSize}
                                                        currentPage={currentPage}
                                                        setCurrentPage={setCurrentPage}
                                                />
                                        </div>
                                </div>
                                <AddIoAllocation
                                        open={isModalOpen}
                                        onCancel={() => {
                                                setIsModalOpen(false);
                                                setEditProject({});
                                        }}
                                        onSubmit={handleAdd}
                                        initialData={editProject}
                                        setEditIoAllocation={setEditProject}
                                />
                        </div>
                </div>
        );
};

export default IoAllocation;
